import SeoText from './SeoText'

export default SeoText
